"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.erp_api = void 0;
var _lsfastapiClient = require("@lsoft/lsfastapi-client");
var openapi = {
  openapi: "3.1.0",
  info: {
    title: "erp-api",
    version: "3.2.0"
  },
  paths: {
    "/base_data": {
      get: {
        tags: ["base_data"],
        summary: "Base Data Get",
        operationId: "base_data_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      },
      patch: {
        tags: ["base_data"],
        summary: "Base Data Patch",
        operationId: "base_data_patch",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/MergeSpecModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/base_data/vatid": {
      get: {
        tags: ["base_data"],
        summary: "Base Data Vatid",
        operationId: "base_data_vatid_get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Source Country Code"
          },
          name: "source_country_code",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Destination Country Code"
          },
          name: "destination_country_code",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            "enum": ["B2B", "B2C"],
            title: "Business Relation"
          },
          name: "business_relation",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            format: "date-time",
            title: "Timestamp"
          },
          name: "timestamp",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/base_data/constant/{name}": {
      get: {
        tags: ["base_data"],
        summary: "Base Data Constant Get",
        operationId: "base_data_constant__name__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Name"
          },
          name: "name",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/selling_platform/{selling_platform_id}": {
      get: {
        tags: ["selling_platform"],
        summary: "Selling Platform Get",
        operationId: "selling_platform__selling_platform_id__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Selling Platform Id"
          },
          name: "selling_platform_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/selling_platform/by_name/{name}": {
      get: {
        tags: ["selling_platform"],
        summary: "Selling Platform By Name Get",
        operationId: "selling_platform_by_name__name__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Name"
          },
          name: "name",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/selling_platforms": {
      get: {
        tags: ["selling_platform"],
        summary: "Selling Platforms Get",
        operationId: "selling_platforms_get",
        parameters: [{
          required: false,
          schema: {
            type: "boolean",
            title: "Active",
            "default": true
          },
          name: "active",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/fulfillment_channel/{fulfillment_channel_id}": {
      get: {
        tags: ["fulfillment_channel"],
        summary: "Fulfillment Channel Get",
        operationId: "fulfillment_channel__fulfillment_channel_id__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Fulfillment Channel Id"
          },
          name: "fulfillment_channel_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/fulfillment_channel/by_name/{fulfillment_channel_name}": {
      get: {
        tags: ["fulfillment_channel"],
        summary: "Fulfillment By Name Get",
        operationId: "fulfillment_channel_by_name__fulfillment_channel_name__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Fulfillment Channel Name"
          },
          name: "fulfillment_channel_name",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/order": {
      post: {
        tags: ["order"],
        summary: "Order Post",
        operationId: "order_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/OrderModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/OrderModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/order/{order_number}": {
      get: {
        tags: ["order"],
        summary: "Order Get",
        operationId: "order__order_number__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Order Number"
          },
          name: "order_number",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["order"],
        summary: "Order Delete",
        operationId: "order__order_number__delete",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Order Number"
          },
          name: "order_number",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["order"],
        summary: "Order Patch",
        operationId: "order__order_number__patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Order Number"
          },
          name: "order_number",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/OrderModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/OrderModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/order/{order_number}/detail": {
      get: {
        tags: ["order"],
        summary: "Order Detail Get",
        operationId: "order__order_number__detail_get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Order Number"
          },
          name: "order_number",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/orders": {
      get: {
        tags: ["order"],
        summary: "Orders Get",
        operationId: "orders_get",
        parameters: [{
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Stati",
            "default": []
          },
          name: "stati",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Selling Platforms",
            "default": []
          },
          name: "selling_platforms",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "integer"
            },
            type: "array",
            title: "Selling Platform Ids",
            "default": []
          },
          name: "selling_platform_ids",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Email"
          },
          name: "email",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            format: "date-time",
            title: "Issue Date Gt"
          },
          name: "issue_date_gt",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/country/{country_code}": {
      get: {
        tags: ["country"],
        summary: "Country Get",
        operationId: "country__country_code__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Country Code"
          },
          name: "country_code",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CountryModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/countries/eu/codes": {
      get: {
        tags: ["country"],
        summary: "Countries Eu Codes Get",
        operationId: "countries_eu_codes_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CountryCodesModel"
                }
              }
            }
          }
        }
      }
    },
    "/countries": {
      get: {
        tags: ["country"],
        summary: "Countries Get",
        operationId: "countries_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CountriesModel"
                }
              }
            }
          }
        }
      }
    },
    "/countries/eu": {
      get: {
        tags: ["country"],
        summary: "Countries Eu Get",
        operationId: "countries_eu_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CountriesModel"
                }
              }
            }
          }
        }
      }
    },
    "/tax_rate/tax_rates_compact": {
      get: {
        tags: ["tax_rate"],
        summary: "Tax Rates Compact Get",
        operationId: "tax_rate_tax_rates_compact_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/TaxRatesCompactModel"
                }
              }
            }
          }
        }
      }
    },
    "/customer/email": {
      get: {
        tags: ["customer"],
        summary: "Customer By Contact Email Get",
        operationId: "customer_email_get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Email"
          },
          name: "email",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CustomerModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/validate_credentials": {
      post: {
        tags: ["customer"],
        summary: "Customer Validate Credentials Post",
        operationId: "customer_validate_credentials_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_customer_validate_credentials_post_customer_validate_credentials_post"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/activate": {
      get: {
        tags: ["customer"],
        summary: "Customer Activate Get",
        operationId: "customer_activate_get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Hash"
          },
          name: "hash",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/search": {
      get: {
        tags: ["customer"],
        summary: "Customer Search Get",
        operationId: "customer_search_get",
        parameters: [{
          required: false,
          schema: {
            type: "string",
            title: "Search String"
          },
          name: "search_string",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/{customer_id}": {
      get: {
        tags: ["customer"],
        summary: "Customer Get",
        operationId: "customer__customer_id__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CustomerModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      put: {
        tags: ["customer"],
        summary: "Customer Put",
        operationId: "customer__customer_id__put",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Force Create",
            "default": false
          },
          name: "force_create",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CustomerModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CustomerModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["customer"],
        summary: "Customer Patch",
        operationId: "customer__customer_id__patch",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Force Create",
            "default": false
          },
          name: "force_create",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_customer_patch_customer__customer_id__patch"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CustomerModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/{customer_id}/vatid": {
      get: {
        tags: ["customer"],
        summary: "Customer Vatid Get",
        operationId: "customer__customer_id__vatid_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Source Country Code"
          },
          name: "source_country_code",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Destination Country Code"
          },
          name: "destination_country_code",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            "enum": ["B2B", "B2C"],
            title: "Business Relation"
          },
          name: "business_relation",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            format: "date-time",
            title: "Timestamp"
          },
          name: "timestamp",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/{customer_id}/detail": {
      get: {
        tags: ["customer"],
        summary: "Customer Detail Get",
        operationId: "customer__customer_id__detail_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/{customer_id}/contact/{contact_id}": {
      get: {
        tags: ["customer"],
        summary: "Customer Contact Get",
        operationId: "customer__customer_id__contact__contact_id__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Contact Id"
          },
          name: "contact_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/contact/{contact_id}/password": {
      put: {
        tags: ["customer"],
        summary: "Customer Contact Password Put",
        operationId: "customer_contact__contact_id__password_put",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Contact Id"
          },
          name: "contact_id",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_customer_contact_password_put_customer_contact__contact_id__password_put"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/contact/exists": {
      get: {
        tags: ["customer"],
        summary: "Customer Contact Exists Get",
        operationId: "customer_contact_exists_get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Email"
          },
          name: "email",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer": {
      post: {
        tags: ["customer"],
        summary: "Customer Post",
        operationId: "customer_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CustomerModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/by_email": {
      "delete": {
        tags: ["customer"],
        summary: "Customer By Email Delete",
        operationId: "customer_by_email_delete",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Email"
          },
          name: "email",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/{customer_id}/orders": {
      get: {
        tags: ["customer"],
        summary: "Router Customer Orders Get",
        operationId: "customer__customer_id__orders_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "path"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Stati",
            "default": []
          },
          name: "stati",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "integer"
            },
            type: "array",
            title: "Selling Platform Ids",
            "default": []
          },
          name: "selling_platform_ids",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Email"
          },
          name: "email",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/{full_tr_number}": {
      get: {
        tags: ["transaction"],
        summary: "Transaction Get",
        operationId: "transaction__full_tr_number__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "FULL"
          },
          name: "filter_class",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["transaction"],
        summary: "Transaction Patch",
        operationId: "transaction__full_tr_number__patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Force Create",
            "default": true
          },
          name: "force_create",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Override Receiver",
            "default": false
          },
          name: "override_receiver",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/TransactionModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/TransactionModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/{full_tr_number}/payments": {
      get: {
        tags: ["transaction"],
        summary: "Transaction Get Payments Get",
        operationId: "transaction__full_tr_number__payments_get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }, {
          required: true,
          schema: {
            items: {},
            type: "array",
            title: "Payment Methods"
          },
          name: "payment_methods",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/full_tr_numbers/order/{order_number}": {
      get: {
        tags: ["transaction"],
        summary: "Transaction Full Tr Numbers Order Number Get",
        operationId: "transaction_full_tr_numbers_order__order_number__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Order Number"
          },
          name: "order_number",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Tr Type Code"
          },
          name: "tr_type_code",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Status"
          },
          name: "status",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/invoice/{full_tr_number}/paid": {
      patch: {
        tags: ["transaction"],
        summary: "Transaction Invoice Set Paid Patch",
        operationId: "transaction_invoice__full_tr_number__paid_patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/{full_tr_number}/append_child": {
      patch: {
        tags: ["transaction"],
        summary: "Transaction Append Child Patch",
        operationId: "transaction__full_tr_number__append_child_patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Child Transaction Full Tr Number"
          },
          name: "child_transaction_full_tr_number",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/{full_tr_number}/append_cv": {
      patch: {
        tags: ["transaction"],
        summary: "Router Transaction Append Cv Patch",
        operationId: "transaction__full_tr_number__append_cv_patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Child Cv Full Tr Number"
          },
          name: "child_cv_full_tr_number",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction": {
      post: {
        tags: ["transaction"],
        summary: "Transaction Post",
        operationId: "transaction_post",
        parameters: [{
          required: false,
          schema: {
            type: "boolean",
            title: "Override Receiver",
            "default": false
          },
          name: "override_receiver",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/TransactionModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/TransactionModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/from_transactions": {
      post: {
        tags: ["transaction"],
        summary: "Transaction From Transactions",
        operationId: "transaction_from_transactions_post",
        parameters: [{
          required: true,
          schema: {
            type: "boolean",
            title: "Takeover All Positions"
          },
          name: "takeover_all_positions",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_transaction_from_transactions_transaction_from_transactions_post"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transactions/invoiced": {
      patch: {
        tags: ["transaction"],
        summary: "Transactions Set Invoiced Patch",
        operationId: "transactions_invoiced_patch",
        parameters: [{
          required: true,
          schema: {
            items: {},
            type: "array",
            title: "Full Tr Numbers"
          },
          name: "full_tr_numbers",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transactions": {
      get: {
        tags: ["transaction"],
        summary: "Transactions Get",
        operationId: "transactions_get",
        parameters: [{
          required: false,
          schema: {
            type: "integer",
            title: "Customer Id"
          },
          name: "customer_id",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Tr Type Codes"
          },
          name: "tr_type_codes",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Flags"
          },
          name: "flags",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Without Flags"
          },
          name: "without_flags",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Stati"
          },
          name: "stati",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Order Stati"
          },
          name: "order_stati",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "integer"
            },
            type: "array",
            title: "Selling Platform Ids",
            "default": []
          },
          name: "selling_platform_ids",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/draft/from_customer_quote_request": {
      post: {
        tags: ["transaction"],
        summary: "Transaction Draft From Customer Quote Request",
        operationId: "transaction_draft_from_customer_quote_request_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CustomerQuoteRequestModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/{full_tr_number}/delivery/set_status": {
      patch: {
        tags: ["transaction"],
        summary: "Transaction Delivery Set Status Patch",
        operationId: "transaction__full_tr_number__delivery_set_status_patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Tr Index Full Tr Number"
          },
          name: "tr_index_full_tr_number",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Tr Index Nr"
          },
          name: "tr_index_nr",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Status"
          },
          name: "status",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            format: "date-time",
            title: "Issue Date"
          },
          name: "issue_date",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                type: "object",
                title: "Delivery Data"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/{full_tr_number}/set_status": {
      patch: {
        tags: ["transaction"],
        summary: "Transaction Set Status Patch",
        operationId: "transaction__full_tr_number__set_status_patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Status"
          },
          name: "status",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/from_pos_sale": {
      post: {
        tags: ["transaction"],
        summary: "Transaction From Pos Sale",
        operationId: "transaction_from_pos_sale_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/FromPosSaleBody"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/FromPosSaleResult"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/from_payment_order": {
      post: {
        tags: ["transaction"],
        summary: "Transaction From Payment Order",
        operationId: "transaction_from_payment_order_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/PaymentOrderModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/transaction/{full_tr_number}/peppol/transfer": {
      patch: {
        tags: ["transaction"],
        summary: "Transaction Peppol Transfer",
        operationId: "transaction__full_tr_number__peppol_transfer_patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/manufacturer/{manufacturer_id}": {
      get: {
        tags: ["manufacturer"],
        summary: "Manufacturer Get",
        operationId: "manufacturer__manufacturer_id__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Manufacturer Id"
          },
          name: "manufacturer_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["manufacturer"],
        summary: "Manufacturer Delete",
        operationId: "manufacturer__manufacturer_id__delete",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Manufacturer Id"
          },
          name: "manufacturer_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/manufacturers": {
      get: {
        tags: ["manufacturer"],
        summary: "Manufacturers Get",
        operationId: "manufacturers_get",
        parameters: [{
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/manufacturer": {
      post: {
        tags: ["manufacturer"],
        summary: "Manufacturer Post",
        operationId: "manufacturer_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ManufacturerModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ManufacturerModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/supplier/{supplier_id}": {
      get: {
        tags: ["supplier"],
        summary: "Supplier Get",
        operationId: "supplier__supplier_id__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Supplier Id"
          },
          name: "supplier_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      put: {
        tags: ["supplier"],
        summary: "Supplier Put",
        operationId: "supplier__supplier_id__put",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Supplier Id"
          },
          name: "supplier_id",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Force Create",
            "default": false
          },
          name: "force_create",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/SupplierModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/SupplierModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["supplier"],
        summary: "Supplier Delete",
        operationId: "supplier__supplier_id__delete",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Supplier Id"
          },
          name: "supplier_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["supplier"],
        summary: "Supplier Patch",
        operationId: "supplier__supplier_id__patch",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Supplier Id"
          },
          name: "supplier_id",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Force Create",
            "default": false
          },
          name: "force_create",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_supplier_patch_supplier__supplier_id__patch"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/SupplierModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/suppliers": {
      get: {
        tags: ["supplier"],
        summary: "Suppliers Get",
        operationId: "suppliers_get",
        parameters: [{
          required: false,
          schema: {
            items: {
              type: "integer"
            },
            type: "array",
            title: "Supplier Ids"
          },
          name: "supplier_ids",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/supplier": {
      post: {
        tags: ["supplier"],
        summary: "Supplier Post",
        operationId: "supplier_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/SupplierModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/suppliers/reorder": {
      get: {
        tags: ["supplier"],
        summary: "Suppliers Reorder Get",
        operationId: "suppliers_reorder_get",
        parameters: [{
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/search": {
      get: {
        tags: ["supplier"],
        summary: "Supplier Search Get",
        operationId: "search_get",
        parameters: [{
          required: false,
          schema: {
            type: "string",
            title: "Search String"
          },
          name: "search_string",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/type_mapping/{set}": {
      get: {
        tags: ["type_mapping"],
        summary: "Type Mapping Get",
        operationId: "type_mapping__set__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Set"
          },
          name: "set",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/type_mappings": {
      get: {
        tags: ["type_mapping"],
        summary: "Type Mappings Get",
        operationId: "type_mappings_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    },
    "/surcharge_discount_cost/{type}": {
      get: {
        tags: ["surcharge discount cost"],
        summary: "Surcharge Discount Cost Get",
        operationId: "surcharge_discount_cost__type__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Type"
          },
          name: "type",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer_card/hash/{hash}": {
      get: {
        tags: ["customer card"],
        summary: "Customer Card Get",
        operationId: "customer_card_hash__hash__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Hash"
          },
          name: "hash",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Remove Transaction Data",
            "default": true
          },
          name: "remove_transaction_data",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer_card/email": {
      get: {
        tags: ["customer card"],
        summary: "Customer Card Email Get",
        operationId: "customer_card_email_get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Email"
          },
          name: "email",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Remove Transaction Data",
            "default": true
          },
          name: "remove_transaction_data",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer_card/digital": {
      post: {
        tags: ["customer card"],
        summary: "Customer Card Digital Post",
        operationId: "customer_card_digital_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CustomerCardModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer_card/hash/{customer_card_hash}": {
      patch: {
        tags: ["customer card"],
        summary: "Customer Card Post",
        operationId: "customer_card_hash__customer_card_hash__patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Customer Card Hash"
          },
          name: "customer_card_hash",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CustomerCardModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer_card/transform": {
      patch: {
        tags: ["customer card"],
        summary: "Customer Card Transform Patch",
        operationId: "customer_card_transform_patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Old Customer Card Hash"
          },
          name: "old_customer_card_hash",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "New Customer Card Hash"
          },
          name: "new_customer_card_hash",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer_card/add_points": {
      patch: {
        tags: ["customer card"],
        summary: "Customer Card Add Points Patch",
        operationId: "customer_card_add_points_patch",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Customer Card Hash"
          },
          name: "customer_card_hash",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Full Tr Number"
          },
          name: "full_tr_number",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/export/mini_pos": {
      get: {
        tags: ["export"],
        summary: "Export Mini Pos Get",
        operationId: "export_mini_pos_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ExportMiniPosModel"
                }
              }
            }
          }
        }
      }
    },
    "/pos/stations": {
      get: {
        tags: ["pos"],
        summary: "Stations",
        operationId: "pos_stations_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/PosStations"
                }
              }
            }
          }
        }
      }
    },
    "/promotion/{name}": {
      get: {
        tags: ["promotion"],
        summary: "Promotion Get",
        operationId: "promotion__name__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Name"
          },
          name: "name",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/PromotionModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/promotions": {
      put: {
        tags: ["promotion"],
        summary: "Promotions Put",
        operationId: "promotions_put",
        parameters: [{
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                type: "object",
                title: "Body",
                "default": {}
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/intrastat/kn8_codes": {
      get: {
        tags: ["intrastat"],
        summary: "Intrastat Kn8 Codes Get",
        operationId: "intrastat_kn8_codes_get",
        parameters: [{
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Kn8 Code"
          },
          name: "kn8_code",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Description"
          },
          name: "description",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/stock/{stock_id}": {
      get: {
        tags: ["stock"],
        summary: "Stock Get",
        operationId: "stock__stock_id__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Stock Id"
          },
          name: "stock_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/StockModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      put: {
        tags: ["stock"],
        summary: "Stock Put",
        operationId: "stock__stock_id__put",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Stock Id"
          },
          name: "stock_id",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/StockModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/StockModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["stock"],
        summary: "Stock Delete",
        operationId: "stock__stock_id__delete",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Stock Id"
          },
          name: "stock_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/stocks": {
      get: {
        tags: ["stock"],
        summary: "Stocks Get",
        operationId: "stocks_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  additionalProperties: {
                    $ref: "#/components/schemas/StockModel"
                  },
                  type: "object",
                  title: "Response Stocks Get Stocks Get"
                }
              }
            }
          }
        }
      }
    },
    "/stock": {
      post: {
        tags: ["stock"],
        summary: "Stock Post",
        operationId: "stock_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/StockModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/StockModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/stock_movement/{stock_movement_id}": {
      get: {
        tags: ["stock_movement"],
        summary: "Stock Movement Get",
        operationId: "stock_movement__stock_movement_id__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Stock Movement Id"
          },
          name: "stock_movement_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/StockMovementModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["stock_movement"],
        summary: "Stock Movement Delete",
        operationId: "stock_movement__stock_movement_id__delete",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Stock Movement Id"
          },
          name: "stock_movement_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["stock_movement"],
        summary: "Stock Movement Patch",
        operationId: "stock_movement__stock_movement_id__patch",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Stock Movement Id"
          },
          name: "stock_movement_id",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/StockMovementModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/stock_movements": {
      get: {
        tags: ["stock_movement"],
        summary: "Stock Movements Get",
        operationId: "stock_movements_get",
        parameters: [{
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Stati"
          },
          name: "stati",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Stock Movement Id Gt"
          },
          name: "stock_movement_id_gt",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            format: "date-time",
            title: "Created Gt"
          },
          name: "created_gt",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Skus"
          },
          name: "skus",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/StockMovementPVResponseModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/stock_movement": {
      post: {
        tags: ["stock_movement"],
        summary: "Stock Movement Post",
        operationId: "stock_movement_post",
        parameters: [{
          required: false,
          schema: {
            type: "string",
            title: "Target Status"
          },
          name: "target_status",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/StockMovementModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/stock_movements/merge": {
      post: {
        tags: ["stock_movement"],
        summary: "Stock Movement Merge Post",
        operationId: "stock_movements_merge_post",
        parameters: [{
          required: false,
          schema: {
            items: {
              type: "integer"
            },
            type: "array",
            title: "Stock Movement Ids"
          },
          name: "stock_movement_ids",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/stock_movement/{stock_movement_id}/update": {
      put: {
        tags: ["stock_movement"],
        summary: "Stock Movement Update",
        operationId: "stock_movement__stock_movement_id__update_put",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Stock Movement Id"
          },
          name: "stock_movement_id",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Discard Open Positions",
            "default": false
          },
          name: "discard_open_positions",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/StockMovementModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/stock_movements/error_follow_up": {
      get: {
        tags: ["stock_movement"],
        summary: "Router Stock Movements Error Get",
        operationId: "stock_movements_error_follow_up_get",
        parameters: [{
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Stati"
          },
          name: "stati",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}": {
      get: {
        tags: ["product"],
        summary: "Product Get",
        operationId: "product__sku__get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "FULL"
          },
          name: "filter_class",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["product"],
        summary: "Product Patch",
        operationId: "product__sku__patch",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Save",
            "default": true
          },
          name: "save",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          },
          name: "render_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render Async",
            "default": false
          },
          name: "render_async",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render All",
            "default": true
          },
          name: "render_all",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Initiate Render",
            "default": true
          },
          name: "initiate_render",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Priority"
          },
          name: "priority",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_product_patch_product__sku__patch"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product": {
      post: {
        tags: ["product"],
        summary: "Product Create",
        operationId: "product_post",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          },
          name: "render_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render Async",
            "default": false
          },
          name: "render_async",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render All",
            "default": true
          },
          name: "render_all",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Initiate Render",
            "default": true
          },
          name: "initiate_render",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Priority"
          },
          name: "priority",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ProductModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/products": {
      get: {
        tags: ["product"],
        summary: "Products Get",
        operationId: "products_get",
        parameters: [{
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Webshop"
          },
          name: "webshop",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Onstock"
          },
          name: "onstock",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "integer"
            },
            type: "array",
            title: "Skus"
          },
          name: "skus",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Mskus"
          },
          name: "mskus",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Promotion"
          },
          name: "promotion",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Group Tags"
          },
          name: "group_tags",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Manufacturer Id"
          },
          name: "manufacturer_id",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Missing Intrastat"
          },
          name: "missing_intrastat",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Supplier Id"
          },
          name: "supplier_id",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "integer"
            },
            type: "array",
            title: "Supplier Ids"
          },
          name: "supplier_ids",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Supplier Skus"
          },
          name: "supplier_skus",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Need Reorder"
          },
          name: "need_reorder",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Kn8 Code"
          },
          name: "kn8_code",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Presale"
          },
          name: "presale",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Gtins"
          },
          name: "gtins",
          "in": "query"
        }, {
          required: false,
          schema: {
            items: {
              type: "integer"
            },
            type: "array",
            title: "Mids"
          },
          name: "mids",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/stock/{stock_id}/storage": {
      patch: {
        tags: ["product"],
        summary: "Product Set Storage Patch",
        operationId: "product__sku__stock__stock_id__storage_patch",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "integer",
            title: "Stock Id"
          },
          name: "stock_id",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "integer",
            title: "Amount"
          },
          name: "amount",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "boolean",
            title: "Relative"
          },
          name: "relative",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Condition",
            "default": "NEW"
          },
          name: "condition",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          },
          name: "render_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render Async",
            "default": false
          },
          name: "render_async",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render All",
            "default": true
          },
          name: "render_all",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Initiate Render",
            "default": true
          },
          name: "initiate_render",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Priority"
          },
          name: "priority",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/stock/{stock_id}": {
      put: {
        tags: ["product"],
        summary: "Product Stock Put",
        operationId: "product__sku__stock__stock_id__put",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "integer",
            title: "Stock Id"
          },
          name: "stock_id",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          },
          name: "render_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render Async",
            "default": false
          },
          name: "render_async",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render All",
            "default": true
          },
          name: "render_all",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Initiate Render",
            "default": true
          },
          name: "initiate_render",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Priority"
          },
          name: "priority",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/StockInfoModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/supplier/{sid}": {
      put: {
        tags: ["product"],
        summary: "Product Supplier Put",
        operationId: "product__sku__supplier__sid__put",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "integer",
            title: "Sid"
          },
          name: "sid",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Is Main Supplier",
            "default": false
          },
          name: "is_main_supplier",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          },
          name: "render_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render Async",
            "default": false
          },
          name: "render_async",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render All",
            "default": true
          },
          name: "render_all",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Initiate Render",
            "default": true
          },
          name: "initiate_render",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Priority"
          },
          name: "priority",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ProductSupplierModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["product"],
        summary: "Product Supplier Delete",
        operationId: "product__sku__supplier__sid__delete",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "integer",
            title: "Sid"
          },
          name: "sid",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          },
          name: "render_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render Async",
            "default": false
          },
          name: "render_async",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render All",
            "default": true
          },
          name: "render_all",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Initiate Render",
            "default": true
          },
          name: "initiate_render",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Priority"
          },
          name: "priority",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/calculation": {
      get: {
        tags: ["product"],
        summary: "Product Calculation Get",
        operationId: "product__sku__calculation_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ProductCalculationModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product_recalculate": {
      patch: {
        tags: ["product"],
        summary: "Product Recalculate Patch",
        operationId: "product_recalculate_patch",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_product_recalculate_patch_product_recalculate_patch"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/reservations": {
      get: {
        tags: ["product"],
        summary: "Product Reservations Get",
        operationId: "product__sku__reservations_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/reservation": {
      put: {
        tags: ["product"],
        summary: "Product Reservations Put",
        operationId: "product__sku__reservation_put",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          },
          name: "render_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render Async",
            "default": false
          },
          name: "render_async",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render All",
            "default": true
          },
          name: "render_all",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Initiate Render",
            "default": true
          },
          name: "initiate_render",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Priority"
          },
          name: "priority",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ProductReservation"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/reservation/{reservation_id}": {
      "delete": {
        tags: ["product"],
        summary: "Product Reservations Delete",
        operationId: "product__sku__reservation__reservation_id__delete",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Reservation Id"
          },
          name: "reservation_id",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Render Class"
          },
          name: "render_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render Async",
            "default": false
          },
          name: "render_async",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Render All",
            "default": true
          },
          name: "render_all",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Initiate Render",
            "default": true
          },
          name: "initiate_render",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Priority"
          },
          name: "priority",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/render_channel_data": {
      get: {
        tags: ["product"],
        summary: "Product Render Channel Data Get",
        operationId: "product__sku__render_channel_data_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  anyOf: [{
                    $ref: "#/components/schemas/RenderChannelDataModel"
                  }, {
                    type: "object"
                  }],
                  title: "Response Product Render Channel Data Get Product  Sku  Render Channel Data Get"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/checksum": {
      get: {
        tags: ["product"],
        summary: "Product Checksum Get",
        operationId: "product__sku__checksum_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ChecksumResponseModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/validation_info": {
      get: {
        tags: ["product"],
        summary: "Product Validation Load",
        operationId: "product__sku__validation_info_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ValidationInfoModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/products/stock/{stock_id}/amounts": {
      patch: {
        tags: ["product"],
        summary: "Products Stock Amounts Set",
        operationId: "products_stock__stock_id__amounts_patch",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Stock Id"
          },
          name: "stock_id",
          "in": "path"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Condition",
            "default": "NEW"
          },
          name: "condition",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Location Short Name"
          },
          name: "location_short_name",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ProductsStockAmountModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/products/stock_movement_suggestions": {
      get: {
        tags: ["product"],
        summary: "Products Stock Movement Suggestions Get",
        operationId: "products_stock_movement_suggestions_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "From Stock Id"
          },
          name: "from_stock_id",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "integer",
            title: "To Stock Id"
          },
          name: "to_stock_id",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/products/stock_movement_target_no_stock": {
      get: {
        tags: ["product"],
        summary: "Products Stock Movement Target No Stock Get",
        operationId: "products_stock_movement_target_no_stock_get",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "From Stock Id"
          },
          name: "from_stock_id",
          "in": "query"
        }, {
          required: true,
          schema: {
            type: "integer",
            title: "To Stock Id"
          },
          name: "to_stock_id",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Skip"
          },
          name: "skip",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "integer",
            title: "Limit"
          },
          name: "limit",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Ids Merge Mode",
            "default": "APPEND"
          },
          name: "ids_merge_mode",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Sort"
          },
          name: "sort",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Options"
          },
          name: "options",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "Filter Class",
            "default": "BASE"
          },
          name: "filter_class",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "boolean",
            title: "Reset",
            "default": false
          },
          name: "reset",
          "in": "query"
        }, {
          required: false,
          schema: {
            type: "string",
            title: "View"
          },
          name: "view",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/stocks/stocktaking": {
      patch: {
        tags: ["product"],
        summary: "Router Product Stocks Stocktaking Update",
        operationId: "product__sku__stocks_stocktaking_patch",
        parameters: [{
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          },
          name: "sku",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_router_product_stocks_stocktaking_update_product__sku__stocks_stocktaking_patch"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/validation_info/{val_class}/{val_uid}": {
      get: {
        tags: ["validation"],
        summary: "Router Validation Info Get",
        operationId: "validation_info__val_class___val_uid__get",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Val Class"
          },
          name: "val_class",
          "in": "path"
        }, {
          required: true,
          schema: {
            type: "string",
            title: "Val Uid"
          },
          name: "val_uid",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/validation_infos/{val_class}": {
      put: {
        tags: ["validation"],
        summary: "Router Validation Infos Get",
        operationId: "validation_infos__val_class__put",
        parameters: [{
          required: true,
          schema: {
            type: "string",
            title: "Val Class"
          },
          name: "val_class",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                title: "Body"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  },
  components: {
    schemas: {
      ActionModel: {
        properties: {
          ACTION_TYPE: {
            type: "string",
            title: "Action Type"
          },
          TIMESTAMP: {
            type: "string",
            format: "date-time",
            title: "Timestamp"
          },
          OPERATOR: {
            type: "string",
            title: "Operator"
          },
          META: {
            type: "object",
            title: "Meta"
          }
        },
        type: "object",
        required: ["ACTION_TYPE", "TIMESTAMP", "OPERATOR", "META"],
        title: "ActionModel"
      },
      AddressModelV2: {
        properties: {
          firstname: {
            type: "string",
            title: "Firstname",
            "default": ""
          },
          lastname: {
            type: "string",
            title: "Lastname",
            "default": ""
          },
          company: {
            type: "string",
            title: "Company",
            "default": ""
          },
          department: {
            type: "string",
            title: "Department",
            "default": ""
          },
          addition: {
            type: "string",
            title: "Addition",
            "default": ""
          },
          street: {
            type: "string",
            title: "Street",
            "default": ""
          },
          city: {
            type: "string",
            title: "City",
            "default": ""
          },
          zipcode: {
            type: "string",
            title: "Zipcode",
            "default": ""
          },
          country_code: {
            type: "string",
            title: "Country Code",
            "default": ""
          },
          pobox_number: {
            type: "string",
            title: "Pobox Number",
            "default": ""
          },
          address_types: {
            items: {
              $ref: "#/components/schemas/AddressTypeEnum"
            },
            type: "array",
            "default": []
          },
          email: {
            type: "string",
            title: "Email",
            nullable: true
          },
          uid: {
            type: "string",
            title: "Uid"
          }
        },
        type: "object",
        title: "AddressModelV2"
      },
      AddressTypeEnum: {
        type: "string",
        "enum": ["STANDARD", "DELIVERY", "INVOICE", "SENDER", "CREATOR", "QUOTE"],
        title: "AddressTypeEnum",
        description: "An enumeration."
      },
      Body_customer_contact_password_put_customer_contact__contact_id__password_put: {
        properties: {
          current_password: {
            type: "string",
            title: "Current Password"
          },
          new_password: {
            type: "string",
            title: "New Password"
          }
        },
        type: "object",
        required: ["current_password", "new_password"],
        title: "Body_customer_contact_password_put_customer_contact__contact_id__password_put"
      },
      Body_customer_patch_customer__customer_id__patch: {
        properties: {
          customer: {
            $ref: "#/components/schemas/CustomerModel"
          },
          _merge_spec: {
            $ref: "#/components/schemas/MergeSpecModel"
          }
        },
        type: "object",
        required: ["customer", "_merge_spec"],
        title: "Body_customer_patch_customer__customer_id__patch"
      },
      Body_customer_validate_credentials_post_customer_validate_credentials_post: {
        properties: {
          email: {
            type: "string",
            title: "Email"
          },
          password: {
            type: "string",
            title: "Password"
          }
        },
        type: "object",
        required: ["email", "password"],
        title: "Body_customer_validate_credentials_post_customer_validate_credentials_post"
      },
      Body_product_patch_product__sku__patch: {
        properties: {
          product: {
            $ref: "#/components/schemas/ProductModel"
          },
          _merge_spec: {
            $ref: "#/components/schemas/MergeSpecModel"
          }
        },
        type: "object",
        required: ["product", "_merge_spec"],
        title: "Body_product_patch_product__sku__patch"
      },
      Body_product_recalculate_patch_product_recalculate_patch: {
        properties: {
          old_calculation: {
            $ref: "#/components/schemas/ProductCalculationModel"
          },
          new_calculation: {
            $ref: "#/components/schemas/ProductCalculationModel"
          }
        },
        type: "object",
        required: ["old_calculation", "new_calculation"],
        title: "Body_product_recalculate_patch_product_recalculate_patch"
      },
      Body_router_product_stocks_stocktaking_update_product__sku__stocks_stocktaking_patch: {
        properties: {
          operator: {
            type: "string",
            title: "Operator"
          },
          stocktaking: {
            additionalProperties: {
              type: "integer"
            },
            type: "object",
            title: "Stocktaking"
          },
          stocktaking_id: {
            type: "integer",
            title: "Stocktaking Id"
          }
        },
        type: "object",
        required: ["operator", "stocktaking"],
        title: "Body_router_product_stocks_stocktaking_update_product__sku__stocks_stocktaking_patch"
      },
      Body_supplier_patch_supplier__supplier_id__patch: {
        properties: {
          supplier: {
            $ref: "#/components/schemas/SupplierModel"
          },
          _merge_spec: {
            $ref: "#/components/schemas/MergeSpecModel"
          }
        },
        type: "object",
        required: ["supplier", "_merge_spec"],
        title: "Body_supplier_patch_supplier__supplier_id__patch"
      },
      Body_transaction_from_transactions_transaction_from_transactions_post: {
        properties: {
          tr_type: {
            type: "string",
            title: "Tr Type"
          },
          sources: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Sources"
          },
          tr_index_takeover: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Tr Index Takeover"
          },
          tr_index_creation: {
            additionalProperties: {
              items: {
                type: "object"
              },
              type: "array"
            },
            type: "object",
            title: "Tr Index Creation"
          },
          consumptions: {
            additionalProperties: {
              type: "number"
            },
            type: "object",
            title: "Consumptions"
          },
          refunds: {
            additionalProperties: {
              type: "number"
            },
            type: "object",
            title: "Refunds"
          },
          action_creation: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Action Creation"
          }
        },
        type: "object",
        required: ["tr_type", "sources", "tr_index_takeover", "tr_index_creation", "consumptions", "refunds", "action_creation"],
        title: "Body_transaction_from_transactions_transaction_from_transactions_post"
      },
      ChecksumResponseModel: {
        properties: {
          checksum: {
            type: "string",
            title: "Checksum"
          },
          sku: {
            type: "integer",
            title: "Sku"
          }
        },
        type: "object",
        required: ["checksum", "sku"],
        title: "ChecksumResponseModel"
      },
      ContactModel: {
        properties: {
          email: {
            type: "string",
            title: "Email",
            "default": ""
          },
          firstname: {
            type: "string",
            title: "Firstname"
          },
          lastname: {
            type: "string",
            title: "Lastname"
          },
          department: {
            type: "string",
            title: "Department",
            "default": ""
          },
          telephone1: {
            type: "string",
            title: "Telephone1",
            "default": ""
          },
          telephone2: {
            type: "string",
            title: "Telephone2",
            "default": ""
          },
          fax: {
            type: "string",
            title: "Fax",
            "default": ""
          },
          password: {
            type: "string",
            title: "Password",
            "default": ""
          },
          language_code: {
            type: "string",
            title: "Language Code",
            "default": ""
          },
          origin_selling_platform: {
            type: "string",
            title: "Origin Selling Platform",
            "default": ""
          },
          contact_type: {
            type: "string",
            title: "Contact Type",
            "default": ""
          },
          title: {
            type: "string",
            title: "Title",
            "default": ""
          },
          contact_flags: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Contact Flags",
            "default": []
          },
          hashes: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Hashes",
            "default": []
          },
          uid: {
            type: "string",
            title: "Uid"
          }
        },
        type: "object",
        required: ["firstname", "lastname", "uid"],
        title: "ContactModel"
      },
      CountriesModel: {
        properties: {
          COUNTRIES: {
            additionalProperties: {
              $ref: "#/components/schemas/CountryModel"
            },
            type: "object",
            title: "Countries"
          }
        },
        type: "object",
        required: ["COUNTRIES"],
        title: "CountriesModel"
      },
      CountryCodesModel: {
        properties: {
          COUNTRY_CODES: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Country Codes"
          }
        },
        type: "object",
        required: ["COUNTRY_CODES"],
        title: "CountryCodesModel"
      },
      CountryModel: {
        properties: {
          COUNTRY_CODE: {
            type: "string",
            title: "Country Code"
          },
          NAME: {
            additionalProperties: {
              type: "string"
            },
            type: "object",
            title: "Name"
          },
          TURN_OVER_LIMIT: {
            type: "number",
            title: "Turn Over Limit"
          },
          EU_COUNTRY: {
            type: "boolean",
            title: "Eu Country"
          },
          CURRENCY: {
            type: "string",
            title: "Currency"
          },
          MINIMUM_ORDER_VALUE: {
            type: "number",
            title: "Minimum Order Value"
          }
        },
        type: "object",
        required: ["COUNTRY_CODE", "NAME", "EU_COUNTRY", "MINIMUM_ORDER_VALUE"],
        title: "CountryModel"
      },
      CustomerCardModel: {
        properties: {
          EMAIL: {
            type: "string",
            title: "Email"
          },
          HASH: {
            type: "string",
            title: "Hash"
          },
          POINTS_TOTAL_GAIN: {
            type: "integer",
            title: "Points Total Gain"
          },
          POINTS_TOTAL_SPENT: {
            type: "number",
            title: "Points Total Spent"
          },
          POINTS_TOTAL_EXPIRED: {
            type: "number",
            title: "Points Total Expired"
          },
          POINTS_TOTAL_AVAILABLE: {
            type: "number",
            title: "Points Total Available"
          },
          POINTS_TOTAL_RETURNED: {
            type: "number",
            title: "Points Total Returned"
          },
          POINTS_CREDIT: {
            items: {},
            type: "array",
            title: "Points Credit"
          },
          POINTS_EXPENSES: {
            items: {},
            type: "array",
            title: "Points Expenses"
          },
          ACTIVATED: {
            type: "string",
            format: "date-time",
            title: "Activated"
          },
          PRINTED: {
            type: "boolean",
            title: "Printed"
          },
          STATUS: {
            type: "string",
            title: "Status"
          },
          FLAGS: {
            items: {},
            type: "array",
            title: "Flags"
          }
        },
        type: "object",
        required: ["EMAIL"],
        title: "CustomerCardModel"
      },
      CustomerModel: {
        properties: {
          addresses: {
            additionalProperties: {
              $ref: "#/components/schemas/AddressModelV2"
            },
            type: "object",
            title: "Addresses"
          },
          company: {
            type: "string",
            title: "Company"
          },
          credit_limit: {
            type: "number",
            title: "Credit Limit"
          },
          time_for_payment: {
            type: "integer",
            title: "Time For Payment"
          },
          customer_flags: {
            items: {},
            type: "array",
            title: "Customer Flags"
          },
          discount: {
            type: "number",
            title: "Discount"
          },
          cash_discount: {
            type: "number",
            title: "Cash Discount"
          },
          comment: {
            type: "string",
            title: "Comment"
          },
          time_for_cash_discount: {
            type: "integer",
            title: "Time For Cash Discount"
          },
          customer_supplier_number: {
            type: "string",
            title: "Customer Supplier Number"
          },
          disabled: {
            type: "boolean",
            title: "Disabled"
          },
          contacts: {
            additionalProperties: {
              $ref: "#/components/schemas/ContactModel"
            },
            type: "object",
            title: "Contacts"
          },
          locations: {
            additionalProperties: {
              $ref: "#/components/schemas/LocationModel"
            },
            type: "object",
            title: "Locations"
          },
          customer_id: {
            type: "integer",
            title: "Customer Id"
          },
          payment_invoice: {
            type: "boolean",
            title: "Payment Invoice"
          },
          website: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Website"
          },
          meta_data: {
            type: "object",
            title: "Meta Data"
          },
          vatids: {
            type: "object",
            title: "Vatids"
          },
          business_relation: {
            type: "string",
            title: "Business Relation"
          },
          shared_account: {
            type: "boolean",
            title: "Shared Account",
            "default": false
          }
        },
        type: "object",
        title: "CustomerModel"
      },
      CustomerQuoteRequestModel: {
        properties: {
          POSITIONS: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Positions"
          },
          CUSTOMER_ID: {
            type: "integer",
            title: "Customer Id"
          },
          FULL_TR_NUMBERS: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Full Tr Numbers"
          },
          SELLING_PLATFORM_ID: {
            type: "integer",
            title: "Selling Platform Id"
          }
        },
        type: "object",
        required: ["POSITIONS", "CUSTOMER_ID", "FULL_TR_NUMBERS", "SELLING_PLATFORM_ID"],
        title: "CustomerQuoteRequestModel"
      },
      EmbActionModel: {
        properties: {
          ACTION_TYPE: {
            type: "string",
            title: "Action Type"
          },
          TIMESTAMP: {
            type: "string",
            format: "date-time",
            title: "Timestamp"
          },
          OPERATOR: {
            type: "string",
            title: "Operator"
          },
          META: {
            type: "object",
            title: "Meta"
          }
        },
        type: "object",
        required: ["ACTION_TYPE", "TIMESTAMP", "OPERATOR"],
        title: "EmbActionModel"
      },
      ExportMiniPosModel: {
        properties: {
          products: {
            additionalProperties: {
              $ref: "#/components/schemas/ExportMiniPosProductModel"
            },
            type: "object",
            title: "Products"
          },
          timestamp: {
            type: "string",
            format: "date-time",
            title: "Timestamp"
          },
          num_products: {
            type: "integer",
            title: "Num Products"
          }
        },
        type: "object",
        required: ["products", "num_products"],
        title: "ExportMiniPosModel"
      },
      ExportMiniPosProductModel: {
        properties: {
          sku: {
            type: "integer",
            title: "Sku"
          },
          gtin: {
            type: "string",
            title: "Gtin"
          },
          msku: {
            type: "string",
            title: "Msku"
          },
          mname: {
            type: "string",
            title: "Mname"
          },
          name: {
            type: "string",
            title: "Name"
          },
          brutto_sp: {
            type: "number",
            title: "Brutto Sp"
          },
          tax_type: {
            type: "string",
            title: "Tax Type"
          },
          no_discount: {
            type: "boolean",
            title: "No Discount"
          }
        },
        type: "object",
        required: ["sku", "brutto_sp", "tax_type", "no_discount"],
        title: "ExportMiniPosProductModel"
      },
      FromPosSaleBody: {
        properties: {
          sale: {
            $ref: "#/components/schemas/PosSale"
          },
          station_number: {
            type: "integer",
            title: "Station Number"
          }
        },
        type: "object",
        required: ["sale", "station_number"],
        title: "FromPosSaleBody"
      },
      FromPosSaleResult: {
        properties: {
          full_tr_number: {
            type: "string",
            title: "Full Tr Number"
          }
        },
        type: "object",
        required: ["full_tr_number"],
        title: "FromPosSaleResult"
      },
      HTTPValidationError: {
        properties: {
          detail: {
            items: {
              $ref: "#/components/schemas/ValidationError"
            },
            type: "array",
            title: "Detail"
          }
        },
        type: "object",
        title: "HTTPValidationError"
      },
      LocationModel: {
        properties: {
          addition: {
            type: "string",
            title: "Addition",
            "default": ""
          },
          street: {
            type: "string",
            title: "Street",
            "default": ""
          },
          zipcode: {
            type: "string",
            title: "Zipcode",
            "default": ""
          },
          city: {
            type: "string",
            title: "City",
            "default": ""
          },
          country_code: {
            type: "string",
            title: "Country Code",
            "default": ""
          },
          pobox_number: {
            type: "string",
            title: "Pobox Number",
            "default": ""
          },
          location_type: {
            type: "string",
            title: "Location Type",
            "default": ""
          },
          uid: {
            type: "string",
            title: "Uid",
            "default": ""
          }
        },
        type: "object",
        title: "LocationModel"
      },
      ManufacturerModel: {
        properties: {
          MANUFACTURER_ID: {
            type: "integer",
            title: "Manufacturer Id"
          },
          NAME: {
            type: "string",
            title: "Name"
          },
          NAME_ALTERNATIVES: {
            items: {},
            type: "array",
            title: "Name Alternatives"
          },
          ASSETS: {
            items: {},
            type: "array",
            title: "Assets"
          }
        },
        type: "object",
        required: ["NAME"],
        title: "ManufacturerModel"
      },
      MergeSpecModel: {
        properties: {
          _merge_spec: {
            type: "object",
            title: " Merge Spec"
          }
        },
        type: "object",
        title: "MergeSpecModel"
      },
      OrderModel: {
        properties: {
          ORDER_NUMBER: {
            type: "string",
            title: "Order Number"
          },
          STATUS: {
            type: "string",
            title: "Status",
            "default": "CREATED"
          },
          ACTION_HISTORY: {
            items: {
              $ref: "#/components/schemas/EmbActionModel"
            },
            type: "array",
            title: "Action History"
          },
          ISSUE_DATE: {
            type: "string",
            format: "date-time",
            title: "Issue Date"
          },
          CUSTOMER_ID: {
            title: "Customer Id"
          }
        },
        type: "object",
        required: ["ORDER_NUMBER", "ACTION_HISTORY"],
        title: "OrderModel"
      },
      PaymentOrderModel: {
        properties: {
          ORDER_NUMBER: {
            type: "string",
            title: "Order Number"
          },
          VERSION: {
            type: "integer",
            title: "Version"
          },
          DATA: {
            type: "object",
            title: "Data"
          },
          EMAIL: {
            type: "string",
            title: "Email"
          },
          STATUS: {
            type: "string",
            title: "Status",
            "default": "CREATED"
          },
          TYPE: {
            type: "string",
            title: "Type",
            "default": "ORDER"
          },
          FLAGS: {
            items: {},
            type: "array",
            title: "Flags"
          },
          LRT_ID: {
            type: "string",
            title: "Lrt Id"
          },
          selling_platform_id: {
            type: "integer",
            title: "Selling Platform Id",
            "default": 7
          },
          fulfillment_channel_id: {
            type: "integer",
            title: "Fulfillment Channel Id",
            "default": 1
          },
          payment_provider: {
            type: "string",
            title: "Payment Provider",
            "default": "MOLLIE"
          }
        },
        type: "object",
        required: ["ORDER_NUMBER", "DATA", "EMAIL"],
        title: "PaymentOrderModel"
      },
      PosSale: {
        properties: {
          positions: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Positions"
          },
          payments: {
            items: {
              $ref: "#/components/schemas/SalePayments"
            },
            type: "array",
            title: "Payments"
          },
          customer_card: {
            type: "string",
            title: "Customer Card"
          },
          issue_date: {
            type: "string",
            format: "date-time",
            title: "Issue Date"
          },
          total_price: {
            type: "number",
            title: "Total Price"
          }
        },
        type: "object",
        required: ["positions", "payments", "issue_date", "total_price"],
        title: "PosSale"
      },
      PosStation: {
        properties: {
          name: {
            type: "string",
            title: "Name"
          },
          number: {
            type: "integer",
            title: "Number"
          }
        },
        type: "object",
        required: ["name", "number"],
        title: "PosStation"
      },
      PosStations: {
        properties: {
          stations: {
            additionalProperties: {
              $ref: "#/components/schemas/PosStation"
            },
            type: "object",
            title: "Stations"
          }
        },
        type: "object",
        required: ["stations"],
        title: "PosStations"
      },
      ProductCalculationModel: {
        properties: {
          overwrite_marge: {
            type: "boolean",
            title: "Overwrite Marge",
            "default": true
          },
          fixed_brutto_sp: {
            type: "boolean",
            title: "Fixed Brutto Sp",
            "default": false
          },
          use_msrp: {
            type: "boolean",
            title: "Use Msrp",
            "default": false
          },
          msrp: {
            type: "number",
            title: "Msrp",
            "default": 0
          },
          netto_pp: {
            type: "number",
            title: "Netto Pp"
          },
          cost_rate: {
            type: "number",
            title: "Cost Rate"
          },
          change_rate: {
            type: "number",
            title: "Change Rate",
            "default": 1
          },
          base_netto_pp: {
            type: "number",
            title: "Base Netto Pp"
          },
          selling_platform_cost_rate: {
            type: "number",
            title: "Selling Platform Cost Rate"
          },
          marge: {
            type: "number",
            title: "Marge"
          },
          base_netto_sp: {
            type: "number",
            title: "Base Netto Sp",
            "default": 0
          },
          avg_tax_rate: {
            type: "number",
            title: "Avg Tax Rate"
          },
          brutto_sp_unrounded: {
            type: "number",
            title: "Brutto Sp Unrounded",
            "default": 0
          },
          round_factor: {
            type: "number",
            title: "Round Factor",
            "default": 0
          },
          brutto_sp: {
            type: "number",
            title: "Brutto Sp",
            "default": 0
          },
          tax_rate: {
            type: "number",
            title: "Tax Rate"
          },
          netto_sp: {
            type: "number",
            title: "Netto Sp",
            "default": 0
          }
        },
        type: "object",
        required: ["netto_pp", "cost_rate", "base_netto_pp", "selling_platform_cost_rate", "marge", "avg_tax_rate"],
        title: "ProductCalculationModel"
      },
      ProductMetaData: {
        properties: {
          calculation: {
            $ref: "#/components/schemas/ProductMetadataCalculationModel"
          },
          change_rates: {
            type: "object",
            title: "Change Rates"
          },
          used_currencies: {
            items: {},
            type: "array",
            title: "Used Currencies"
          },
          reservations: {
            additionalProperties: {
              $ref: "#/components/schemas/ProductReservation"
            },
            type: "object",
            title: "Reservations"
          },
          stock_movements: {
            type: "object",
            title: "Stock Movements"
          },
          minimum_order_quantity: {
            type: "number",
            title: "Minimum Order Quantity",
            "default": 1
          },
          purchase_units: {
            items: {},
            type: "array",
            title: "Purchase Units"
          },
          pim_shared_data: {
            type: "object",
            title: "Pim Shared Data"
          }
        },
        type: "object",
        title: "ProductMetaData"
      },
      ProductMetadataCalculationModel: {
        properties: {
          marge: {
            type: "number",
            title: "Marge",
            "default": 0
          },
          round_factor: {
            type: "number",
            title: "Round Factor",
            "default": 0
          },
          currency: {
            type: "string",
            title: "Currency",
            "default": "EUR"
          },
          prices: {
            type: "object",
            title: "Prices"
          },
          fixed_brutto_sp: {
            type: "boolean",
            title: "Fixed Brutto Sp",
            "default": false
          },
          overwrite_marge: {
            type: "boolean",
            title: "Overwrite Marge",
            "default": true
          },
          netto_pp: {
            type: "number",
            title: "Netto Pp",
            "default": 0
          },
          base_netto_pp: {
            type: "number",
            title: "Base Netto Pp",
            "default": 0
          },
          mix_netto_pp: {
            type: "number",
            title: "Mix Netto Pp",
            "default": 0
          },
          cost_rate: {
            type: "number",
            title: "Cost Rate",
            "default": 0
          },
          use_msrp: {
            type: "boolean",
            title: "Use Msrp",
            "default": false
          }
        },
        type: "object",
        title: "ProductMetadataCalculationModel"
      },
      ProductModel: {
        properties: {
          SKU: {
            type: "integer",
            title: "Sku"
          },
          STATUS: {
            type: "boolean",
            title: "Status"
          },
          CATEGORY_PATH: {
            type: "string",
            title: "Category Path"
          },
          DELIVERY_TIME_WORKING_DAYS: {
            type: "integer",
            title: "Delivery Time Working Days"
          },
          DELIVERY_DATE: {
            type: "string",
            format: "date-time",
            title: "Delivery Date"
          },
          SALE: {
            type: "object",
            title: "Sale"
          },
          PURCHASE: {
            type: "object",
            title: "Purchase"
          },
          STOCK: {
            items: {},
            type: "array",
            title: "Stock"
          },
          SURCHARGE_DISCOUNT_COST: {
            items: {},
            type: "array",
            title: "Surcharge Discount Cost"
          },
          ATTRIBUTES: {
            items: {},
            type: "array",
            title: "Attributes"
          },
          NEEDED_ATTRIBUTES: {
            items: {},
            type: "array",
            title: "Needed Attributes"
          },
          FLAGS: {
            items: {},
            type: "array",
            title: "Flags"
          },
          META_DATA: {
            $ref: "#/components/schemas/ProductMetaData"
          },
          requested_selling_platforms: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Requested Selling Platforms"
          },
          selling_platforms: {
            type: "object",
            title: "Selling Platforms"
          },
          suppliers: {
            type: "object",
            title: "Suppliers"
          },
          promotions: {
            type: "object",
            title: "Promotions"
          },
          requested_data_compatibility: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Requested Data Compatibility"
          },
          data_compatibility: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Data Compatibility"
          }
        },
        type: "object",
        title: "ProductModel"
      },
      ProductReservation: {
        properties: {
          reservation_id: {
            type: "string",
            title: "Reservation Id"
          },
          amount: {
            type: "number",
            title: "Amount"
          },
          stock_id: {
            type: "integer",
            title: "Stock Id"
          },
          condition: {
            type: "string",
            title: "Condition"
          },
          expires: {
            type: "string",
            format: "date-time",
            title: "Expires"
          }
        },
        type: "object",
        required: ["amount", "condition"],
        title: "ProductReservation"
      },
      ProductSupplierModel: {
        properties: {
          active: {
            type: "boolean",
            title: "Active"
          },
          currency: {
            type: "string",
            title: "Currency",
            "default": "EUR"
          },
          minimum_order_quantity: {
            type: "number",
            title: "Minimum Order Quantity"
          },
          prices: {
            type: "object",
            title: "Prices",
            "default": {}
          },
          sid: {
            type: "integer",
            title: "Sid"
          },
          sname: {
            type: "string",
            title: "Sname"
          },
          ssku: {
            type: "string",
            title: "Ssku"
          }
        },
        type: "object",
        required: ["active", "minimum_order_quantity", "sid", "sname", "ssku"],
        title: "ProductSupplierModel"
      },
      ProductsStockAmountModel: {
        properties: {
          products: {
            additionalProperties: {
              type: "number"
            },
            type: "object",
            title: "Products"
          }
        },
        type: "object",
        required: ["products"],
        title: "ProductsStockAmountModel"
      },
      PromotionModel: {
        properties: {
          name: {
            type: "string",
            title: "Name"
          },
          start_date: {
            type: "string",
            format: "date-time",
            title: "Start Date"
          },
          end_date: {
            type: "string",
            format: "date-time",
            title: "End Date"
          },
          discount_rate: {
            type: "number",
            title: "Discount Rate"
          },
          selling_platforms: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Selling Platforms"
          },
          only_stock: {
            type: "boolean",
            title: "Only Stock",
            "default": true
          },
          name_text: {
            additionalProperties: {
              type: "string"
            },
            type: "object",
            title: "Name Text"
          },
          discount_type: {
            type: "string",
            "enum": ["STANDARD"],
            title: "Discount Type",
            "default": "STANDARD"
          },
          meta_data: {
            type: "object",
            title: "Meta Data"
          }
        },
        type: "object",
        required: ["name", "start_date", "end_date", "discount_rate", "selling_platforms", "name_text"],
        title: "PromotionModel"
      },
      RenderChannelDataModel: {
        properties: {
          org_id: {
            type: "string",
            title: "Org Id"
          },
          type: {
            type: "string",
            title: "Type",
            "default": "product"
          },
          channel: {
            type: "string",
            title: "Channel"
          },
          sku: {
            type: "integer",
            title: "Sku"
          },
          checksum: {
            type: "string",
            title: "Checksum"
          },
          data: {
            type: "object",
            title: "Data"
          }
        },
        type: "object",
        required: ["channel", "checksum", "data"],
        title: "RenderChannelDataModel"
      },
      SalePayments: {
        properties: {
          amount: {
            type: "number",
            title: "Amount"
          },
          payment_method: {
            type: "string",
            title: "Payment Method"
          }
        },
        type: "object",
        required: ["amount", "payment_method"],
        title: "SalePayments"
      },
      StockInfoModel: {
        properties: {
          STOCK_ID: {
            type: "integer",
            title: "Stock Id"
          },
          MIN: {
            type: "integer",
            title: "Min"
          },
          MAX: {
            type: "integer",
            title: "Max"
          },
          DELIVERY_TIME_WORKING_DAYS: {
            type: "integer",
            title: "Delivery Time Working Days"
          }
        },
        type: "object",
        required: ["STOCK_ID", "MIN", "MAX", "DELIVERY_TIME_WORKING_DAYS"],
        title: "StockInfoModel"
      },
      StockModel: {
        properties: {
          STOCK_ID: {
            type: "integer",
            title: "Stock Id"
          },
          NAME: {
            type: "string",
            title: "Name"
          },
          DELIVERY_TIME: {
            type: "integer",
            title: "Delivery Time",
            "default": 0
          },
          STOCK_TYPE: {
            $ref: "#/components/schemas/StockTypeEnum"
          },
          SUPPLIER_ID: {
            type: "integer",
            title: "Supplier Id"
          }
        },
        type: "object",
        required: ["NAME", "STOCK_TYPE"],
        title: "StockModel"
      },
      StockMovementBaseModel: {
        properties: {
          STOCK_MOVEMENT_ID: {
            type: "integer",
            title: "Stock Movement Id"
          }
        },
        type: "object",
        title: "StockMovementBaseModel"
      },
      StockMovementModel: {
        properties: {
          STOCK_MOVEMENT_ID: {
            type: "integer",
            title: "Stock Movement Id"
          },
          ACTION_HISTORY: {
            items: {
              $ref: "#/components/schemas/ActionModel"
            },
            type: "array",
            title: "Action History",
            "default": []
          },
          FROM: {
            type: "object",
            title: "From"
          },
          TO: {
            type: "object",
            title: "To"
          },
          POSITIONS: {
            items: {
              $ref: "#/components/schemas/StockMovementPositionModel"
            },
            type: "array",
            title: "Positions"
          },
          STATUS: {
            $ref: "#/components/schemas/StockMovementStatusEnum"
          },
          FULL_TR_NUMBER: {
            type: "string",
            title: "Full Tr Number"
          },
          META: {
            type: "object",
            title: "Meta",
            "default": {}
          },
          LRT_ID_PICKING: {
            type: "string",
            title: "Lrt Id Picking"
          },
          LRT_ID_PLACING: {
            type: "string",
            title: "Lrt Id Placing"
          }
        },
        type: "object",
        required: ["POSITIONS", "STATUS"],
        title: "StockMovementModel"
      },
      StockMovementPVResponseModel: {
        properties: {
          data: {
            type: "object",
            title: "Data",
            "default": {}
          },
          skip: {
            type: "integer",
            title: "Skip",
            nullable: true
          },
          limit: {
            type: "integer",
            title: "Limit",
            nullable: true
          },
          max_results: {
            type: "integer",
            title: "Max Results"
          },
          sort: {
            type: "object",
            title: "Sort"
          },
          view: {
            type: "string",
            title: "View"
          },
          ids: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Ids",
            "default": []
          },
          STOCK_MOVEMENTS: {
            additionalProperties: {
              anyOf: [{
                $ref: "#/components/schemas/StockMovementModel"
              }, {
                $ref: "#/components/schemas/StockMovementBaseModel"
              }]
            },
            type: "object",
            title: "Stock Movements",
            "default": {}
          }
        },
        type: "object",
        title: "StockMovementPVResponseModel"
      },
      StockMovementPositionModel: {
        properties: {
          SKU: {
            type: "integer",
            title: "Sku"
          },
          CONDITION: {
            type: "string",
            title: "Condition"
          },
          FROM_LOCATION_ID: {
            type: "string",
            title: "From Location Id"
          },
          TO_LOCATION_ID: {
            type: "string",
            title: "To Location Id"
          },
          NAME: {
            type: "string",
            title: "Name"
          },
          AMOUNT: {
            type: "integer",
            title: "Amount"
          },
          AMOUNT_PLACED: {
            type: "integer",
            title: "Amount Placed",
            "default": 0
          },
          AMOUNT_PICKED: {
            type: "integer",
            title: "Amount Picked",
            "default": 0
          },
          UNIT: {
            type: "string",
            title: "Unit"
          },
          NETTO_EUR_PP: {
            type: "number",
            title: "Netto Eur Pp"
          },
          TOTAL_NETTO_EUR_PP: {
            type: "number",
            title: "Total Netto Eur Pp"
          }
        },
        type: "object",
        required: ["SKU", "AMOUNT"],
        title: "StockMovementPositionModel"
      },
      StockMovementStatusEnum: {
        type: "string",
        "enum": ["CREATED", "PLANED", "PICKED", "PLACED", "CANCELED", "MERGED"],
        title: "StockMovementStatusEnum",
        description: "An enumeration."
      },
      StockTypeEnum: {
        type: "string",
        "enum": ["STANDARD", "TEMPORARY", "EXTERN", "SUPPLIER", "SELLABLE", "TRANSIT_AMAZON", "SCRAPPING", "TRANSFER", "DISABLED"],
        title: "StockTypeEnum",
        description: "An enumeration."
      },
      SupplierModel: {
        properties: {
          company: {
            type: "string",
            title: "Company"
          },
          supplier_id: {
            type: "integer",
            title: "Supplier Id"
          },
          addresses: {
            additionalProperties: {
              $ref: "#/components/schemas/AddressModelV2"
            },
            type: "object",
            title: "Addresses"
          },
          business_relation: {
            type: "string",
            title: "Business Relation"
          },
          cash_discount: {
            type: "number",
            title: "Cash Discount",
            "default": 0
          },
          charge_vat: {
            type: "boolean",
            title: "Charge Vat",
            "default": false
          },
          comment: {
            type: "string",
            title: "Comment",
            "default": ""
          },
          contacts: {
            additionalProperties: {
              $ref: "#/components/schemas/ContactModel"
            },
            type: "object",
            title: "Contacts"
          },
          credit_limit: {
            type: "number",
            title: "Credit Limit",
            "default": 0
          },
          currency: {
            type: "string",
            title: "Currency",
            "default": "EUR"
          },
          customer_number: {
            type: "string",
            title: "Customer Number"
          },
          free_shipping_value: {
            type: "number",
            title: "Free Shipping Value",
            nullable: true
          },
          language_code: {
            type: "string",
            title: "Language Code",
            "default": ""
          },
          locations: {
            additionalProperties: {
              $ref: "#/components/schemas/LocationModel"
            },
            type: "object",
            title: "Locations"
          },
          minimum_order_value: {
            type: "number",
            title: "Minimum Order Value",
            "default": 0
          },
          minimum_order_value_surcharge: {
            type: "number",
            title: "Minimum Order Value Surcharge",
            "default": 0
          },
          on_stock_delivery_time: {
            type: "integer",
            title: "On Stock Delivery Time",
            nullable: true
          },
          payment_method: {
            type: "string",
            title: "Payment Method",
            "default": ""
          },
          ranking: {
            type: "integer",
            title: "Ranking",
            "default": 1
          },
          shipping_method: {
            type: "string",
            title: "Shipping Method",
            "default": ""
          },
          status: {
            type: "boolean",
            title: "Status",
            "default": true
          },
          stock: {
            type: "integer",
            title: "Stock",
            nullable: true
          },
          time_for_cash_discount: {
            type: "integer",
            title: "Time For Cash Discount",
            "default": 0
          },
          time_for_payment: {
            type: "integer",
            title: "Time For Payment",
            "default": 0
          },
          vatids: {
            type: "object",
            title: "Vatids"
          }
        },
        type: "object",
        required: ["company"],
        title: "SupplierModel"
      },
      TaxRatesCompactModel: {
        properties: {
          TAX_TYPES: {
            additionalProperties: {
              type: "integer"
            },
            type: "object",
            title: "Tax Types"
          },
          TAX_RATES: {
            additionalProperties: {
              additionalProperties: {
                type: "integer"
              },
              type: "object"
            },
            type: "object",
            title: "Tax Rates"
          }
        },
        type: "object",
        required: ["TAX_TYPES", "TAX_RATES"],
        title: "TaxRatesCompactModel"
      },
      TransactionModel: {
        properties: {
          FULL_TR_NUMBER: {
            type: "string",
            title: "Full Tr Number"
          },
          BASE_DATA: {
            type: "object",
            title: "Base Data"
          },
          SENDER: {
            type: "object",
            title: "Sender"
          },
          ADDRESSES: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Addresses"
          },
          PAYMENTS: {
            items: {},
            type: "array",
            title: "Payments"
          },
          RECEIVER: {
            type: "object",
            title: "Receiver"
          },
          SELLING_PLATFORM: {
            type: "object",
            title: "Selling Platform"
          },
          FULFILLMENT_CHANNEL: {
            type: "object",
            title: "Fulfillment Channel"
          },
          CHANGE_RATE: {
            type: "number",
            title: "Change Rate"
          },
          STATUS: {
            type: "string",
            title: "Status"
          },
          CURRENCY: {
            type: "string",
            title: "Currency"
          },
          ISSUE_DATE: {
            type: "string",
            format: "date-time",
            title: "Issue Date"
          },
          DELIVERIES: {
            items: {},
            type: "array",
            title: "Deliveries"
          },
          CHILDREN: {
            items: {},
            type: "array",
            title: "Children"
          },
          ORDERS: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Orders"
          },
          ACTION_HISTORY: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Action History"
          },
          SURCHARGE_DISCOUNT_COST: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Surcharge Discount Cost"
          },
          FLAGS: {
            items: {},
            type: "array",
            title: "Flags"
          },
          CUSTOMER_REFERENCES: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Customer References"
          },
          COMMENTS: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Comments"
          },
          TOTAL_PRICE: {
            type: "number",
            title: "Total Price"
          },
          TOTAL_TAX: {
            type: "number",
            title: "Total Tax"
          },
          TAX_TABLE: {
            items: {
              type: "object"
            },
            type: "array",
            title: "Tax Table"
          },
          TAX_REFUNDABLE: {
            type: "boolean",
            title: "Tax Refundable"
          },
          BUSINESS_RELATION: {
            type: "string",
            title: "Business Relation"
          },
          CHARGE_VAT: {
            type: "boolean",
            title: "Charge Vat"
          },
          DOMESTIC: {
            type: "boolean",
            title: "Domestic"
          },
          SOURCE_VATID: {
            type: "string",
            title: "Source Vatid"
          },
          DESTINATION_VATID: {
            type: "string",
            title: "Destination Vatid"
          },
          SOURCE_COUNTRY_CODE: {
            type: "string",
            title: "Source Country Code"
          },
          DESTINATION_COUNTRY_CODE: {
            type: "string",
            title: "Destination Country Code"
          },
          META_DATA: {
            type: "object",
            title: "Meta Data"
          },
          VATMOSS: {
            type: "boolean",
            title: "Vatmoss"
          }
        },
        type: "object",
        title: "TransactionModel"
      },
      ValidationError: {
        properties: {
          loc: {
            items: {
              anyOf: [{
                type: "string"
              }, {
                type: "integer"
              }]
            },
            type: "array",
            title: "Location"
          },
          msg: {
            type: "string",
            title: "Message"
          },
          type: {
            type: "string",
            title: "Error Type"
          }
        },
        type: "object",
        required: ["loc", "msg", "type"],
        title: "ValidationError"
      },
      ValidationFieldResultModel: {
        properties: {
          valid: {
            type: "boolean",
            title: "Valid"
          },
          error: {
            type: "string",
            title: "Error"
          },
          compatibilities: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Compatibilities",
            "default": []
          }
        },
        type: "object",
        required: ["valid"],
        title: "ValidationFieldResultModel"
      },
      ValidationInfoMetaDataModel: {
        properties: {
          fields: {
            additionalProperties: {
              $ref: "#/components/schemas/ValidationFieldResultModel"
            },
            type: "object",
            title: "Fields",
            "default": {}
          }
        },
        type: "object",
        title: "ValidationInfoMetaDataModel"
      },
      ValidationInfoModel: {
        properties: {
          val_class: {
            type: "string",
            title: "Val Class"
          },
          val_uid: {
            type: "string",
            title: "Val Uid"
          },
          checksum: {
            type: "string",
            title: "Checksum"
          },
          data_compatibility: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Data Compatibility"
          },
          meta_data: {
            $ref: "#/components/schemas/ValidationInfoMetaDataModel"
          }
        },
        type: "object",
        title: "ValidationInfoModel"
      }
    }
  }
};
var erp_api = exports.erp_api = (0, _lsfastapiClient.Api)(openapi);
//# sourceMappingURL=index.js.map